module.exports = __webpack_public_path__ + "img/1.2934345f.jpg";